import React from 'react';
import { IonButton, IonIcon, IonText, IonCard, IonCardContent } from '@ionic/react';
import { checkmarkCircle, arrowBack } from 'ionicons/icons';
import { useLocation } from 'react-router-dom';
import PaymentPageLayout from './PaymentPageLayout';
import styles from './PaymentPages.module.css';

const PaymentSuccessPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const deviceId = queryParams.get('deviceId');

  return (
    <PaymentPageLayout title="Payment Successful">
      <div className={styles.paymentPageContainer}>
        <IonIcon
          icon={checkmarkCircle}
          className={`${styles.icon} ${styles.success}`}
        />
        
        <IonText color="dark">
          <h1 className={styles.title}>Payment Successful!</h1>
          <p className={styles.subtitle}>Your payment has been processed successfully.</p>
        </IonText>
        
        <IonCard className={styles.card}>
          <IonCardContent className={styles.cardContent}>
            <p>
              Your device subscription is now active. You can now enjoy all the features of your OnlyCat device.
            </p>
            <p>
              Thank you for your purchase!
            </p>
          </IonCardContent>
        </IonCard>
        
        {deviceId && (
          <IonButton
            expand="block"
            className={styles.button}
            routerLink={`/devices/${deviceId}`}
          >
            <IonIcon slot="start" icon={arrowBack} />
            Return to Device
          </IonButton>
        )}
      </div>
    </PaymentPageLayout>
  );
};

export default PaymentSuccessPage;